import { cn } from '@/lib/utils';

interface ThumbnailSkeletonProps {
    className?: string;
}

export function ThumbnailSkeleton({ className }: ThumbnailSkeletonProps) {
    return (
        <div
            aria-hidden
            className={cn(
                'skeleton-item-container relative w-full aspect-video overflow-hidden rounded-[5px] border border-grey-500',
                className,
            )}
        >
            <div className="skeleton-item absolute inset-x-[5px] bottom-[5px] h-4 w-1/2 rounded-[4px]" />
        </div>
    );
}
